import { useEffect, useState } from "react";
import logo from "../../images/bingold.png";
import { Menu, X } from "lucide-react";
import { NavLink, Link } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import LogoutPop from "../../commonComponent/LogoutPopup/LogoutPop";
import wallet from "../../images/icons/deposit.png";
import certik from "../../images/audit.png";
import { useGetProfileData } from "../../reactHook/personalSettingHook";

const Navbar = () => {
  const { userID, logout } = useUser();
  const {
    mutate: postData,
    data: profileDataResponse,
    isPending,
  } = useGetProfileData();

  useEffect(() => {
    if (!userID) return;
    postData(userID, {
      onSuccess: () => {
        console.log("..");
      },
      onError: (error) => {
        if (error.response.status === 401) {
          logout();
        }
      },
    });
  }, [userID]);

  const [isTopDrawerOpen, setIsTopDrawerOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  useEffect(() => {
    setIsAuthenticated(!!userID);
  }, [userID]);

  // Google Translator

  useEffect(() => {
    if (window.googleTranslateScriptAdded) return;
    window.googleTranslateScriptAdded = true;

    window.googleTranslateElementInit = function () {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          autoDisplay: false,
        },
        "google_translate_element"
      );
    };

    const addScript = document.createElement("script");
    addScript.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    addScript.async = true;
    document.body.appendChild(addScript);
  }, []);

  return (
    <nav
      className="w-full fixed top-0 z-[1000]"
      style={{
        background: `
        radial-gradient(circle at center, rgba(4, 69, 114, 0.4) 0%, rgba(0, 0, 0, 1) 80%)
      `,
        backgroundColor: "#000",
        backdropFilter: "blur(10px)",
      }}
    >
      <div className="text-white px-6 py-4 md:px-10 md:py-5 flex justify-between items-center">
        <Link to="/">
          <img
            src={logo}
            alt="Logo"
            className="h-[32px] w-[160px] object-contain md:h-[52px] md:w-[220px]"
          />
        </Link>
        <div className="hidden md:block ">
          <div className="flex items-center gap-8">
            {!isAuthenticated ? (
              <ul className="flex gap-8 items-center text-lg font-light">
                <div className="h-10">
                  <div id="google_translate_element" className="mr-4 "></div>
                </div>
                {/* <li className="cursor-pointer">
                  <Link to="/all_news">
                    <p>News</p>
                  </Link>
                </li> */}

                <li>
                  <a
                    href="/whitepaper.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white"
                  >
                    Whitepaper
                  </a>
                </li>
                <li className="cursor-pointer">
                  <a href="#tokenomics">Tokenization</a>
                </li>
                <li className="cursor-pointer">
                  <a href="#about">About</a>
                </li>
                {/* <li className="cursor-pointer">
                  <a href="#faq">FAQ</a>
                </li> */}
                {/* <li className="cursor-pointer">
                  <Link to="/all_blogs">
                    <p>Blogs</p>
                  </Link>
                </li> */}
                {/* <li className="cursor-pointer">
                  <a
                    to="#"
                    onClick={() => setIsTopDrawerOpen(!isTopDrawerOpen)}
                  >
                    Update
                  </a>
                </li> */}
                <li className="cursor-pointer">
                  <a
                    href="https://skynet.certik.com/projects/bingold"
                    target="_blank"
                  >
                    <img
                      src={certik}
                      alt="Certik"
                      style={{ height: "45px" }}
                    ></img>
                  </a>
                </li>
              </ul>
            ) : (
              <ul className="flex gap-6 text-lg font-light">
                <li className="cursor-pointer">
                  <NavLink to="/token">Token</NavLink>
                </li>
                <li className="cursor-pointer">
                  <NavLink to="/deposit">Deposit</NavLink>
                </li>
                <li className="cursor-pointer">
                  <NavLink to="/deposit-history">Deposit History</NavLink>
                </li>
                <li className="cursor-pointer">
                  <NavLink to="/profile">Profile</NavLink>
                </li>

                {!isPending && (
                  <li className="cursor-pointer">
                    <NavLink to="#" className="flex items-center gap-2">
                      <img
                        src={wallet}
                        alt="Wallet"
                        className="h-[16px] w-[20px] object-contain"
                      />
                      <span className="text-md">
                        $
                        {profileDataResponse?.data?.account_bal === null
                          ? 0
                          : profileDataResponse?.data?.account_bal}
                      </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            )}
            {!isAuthenticated ? (
              <div className="flex gap-4 items-center">
                <div className=" p-[2px]  bg-[#000] w-[100px] text-white rounded-md bg-[linear-gradient(86.92deg,#37ABFF_11.12%,rgba(255,255,255,0.2)_81.99%)]">
                  <NavLink
                    to="https://investor.bingold.to/signup"
                    target="_self"
                  >
                    <button className="bg-[#000] text-white h-[32px] w-full rounded-md font-semibold text-sm tracking-wide">
                      Sign Up
                    </button>
                  </NavLink>
                </div>
                <div className="rounded-md bg-[linear-gradient(86.92deg,#37ABFF_11.12%,rgba(255,255,255,0.2)_81.99%)] w-[100px] p-[2px] inline-block">
                  <NavLink
                    to="https://investor.bingold.to/login"
                    className="block bg-[#FFD700] p-[6px_8px] text-black  rounded-md font-semibold text-sm text-center"
                  >
                    Login
                  </NavLink>
                </div>
              </div>
            ) : (
              <div className="ml-6 p-[2px] rounded-md bg-[linear-gradient(86.92deg,#37ABFF_11.12%,rgba(255,255,255,0.2)_81.99%)]">
                <button
                  onClick={() => setShowLogoutPopup(true)}
                  className="bg-[#ffd700] text-black h-[37px] px-5 rounded-md font-semibold text-sm tracking-wide"
                >
                  Logout
                </button>
              </div>
            )}
          </div>

          {/* {isTopDrawerOpen && (
            <div
              className="w-full fixed left-0 top-0 z-[1500] shadow-lg p-6 flex flex-col gap-4 text-xl"
              style={{
                background: `
        radial-gradient(circle at center, rgba(4, 69, 114, 0.4) 0%, rgba(0, 0, 0, 1) 80%)
      `,
                backgroundColor: "#000",
                backdropFilter: "blur(10px)",
              }}
            >
              <button
                onClick={() => setIsTopDrawerOpen(false)}
                className="absolute right-4 top-4"
              >
                <X size={24} />
              </button>
              <a href="#blog" className="hover:text-yellow-400"  onClick={() => setIsTopDrawerOpen(false)}>
                Blog
              </a>
              <a href="#advertiser" className="hover:text-yellow-400"  onClick={() => setIsTopDrawerOpen(false)}>
                Advertiser
              </a>
              <a href="#news" className="hover:text-yellow-400"  onClick={() => setIsTopDrawerOpen(false)}>
                News
              </a>
            </div>
          )} */}
        </div>
        <div className="md:hidden  block">
          <button onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>

          {isMenuOpen && (
            <div className="absolute top-16 left-0 w-full bg-black/90 z-50 px-6 py-4">
              {!isAuthenticated ? (
                <ul className="flex flex-col gap-6 text-lg font-light">
                  <li className="cursor-pointer">
                    <Link to="/" onClick={() => setIsMenuOpen(false)}>
                      Home
                    </Link>
                  </li>

                  <li>
                    <a href="/whitepaper.pdf" className="hover:text-white">
                      Whitepaper
                    </a>
                  </li>

                  <li className="cursor-pointer">
                    <a href="#tokenomics" onClick={() => setIsMenuOpen(false)}>
                      Tokenomics
                    </a>
                  </li>
                  <li className="cursor-pointer">
                    <a href="#roadmap" onClick={() => setIsMenuOpen(false)}>
                      Roadmap
                    </a>
                  </li>
                  <li className="cursor-pointer">
                    <a href="#faq" onClick={() => setIsMenuOpen(false)}>
                      FAQ
                    </a>
                  </li>
                  {/* <li className="cursor-pointer">
                    <a
                      href="https://skynet.certik.com/projects/bingold"
                      target="_blank"
                    >
                      <img
                        src={certik}
                        alt="Certik"
                        style={{ height: "50px", width: "180px" }}
                      ></img>
                    </a>
                  </li> */}
                </ul>
              ) : (
                <ul className="flex flex-col gap-6 text-lg font-light">
                  <li className="cursor-pointer">
                    <NavLink to="/token" onClick={() => setIsMenuOpen(false)}>
                      Token
                    </NavLink>
                  </li>
                  <li className="cursor-pointer">
                    <NavLink to="/deposit" onClick={() => setIsMenuOpen(false)}>
                      Deposit
                    </NavLink>
                  </li>
                  <li className="cursor-pointer">
                    <NavLink
                      to="/deposit-history"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Deposit History
                    </NavLink>
                  </li>
                  <li className="cursor-pointer">
                    <NavLink to="/profile" onClick={() => setIsMenuOpen(false)}>
                      Profile
                    </NavLink>
                  </li>
                  {!isPending && (
                    <li className="cursor-pointer">
                      <NavLink to="#" className="flex items-center gap-2">
                        <img
                          src={wallet}
                          alt="Wallet"
                          className="h-[16px] w-[20px] object-contain"
                        />
                        <span className="text-sm">
                          $
                          {profileDataResponse?.data?.account_bal === null
                            ? 0
                            : profileDataResponse?.data?.account_bal}
                        </span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              )}
              <div className="mt-6">
                {!isAuthenticated ? (
                  <div className="flex flex-row gap-3">
                    <div className=" p-[2px]  h-[40px] bg-[#000] w-[100px] text-white rounded-md bg-[linear-gradient(86.92deg,#37ABFF_11.12%,rgba(255,255,255,0.2)_81.99%)]">
                      <NavLink
                        to="https://investor.bingold.to/login"
                        target="_self"
                      >
                        <button className="bg-[#000] text-white h-[36px] w-full rounded-md font-semibold text-sm tracking-wide">
                          Login
                        </button>
                      </NavLink>
                    </div>
                    <div className=" p-[2px]  h-[40px] bg-[#000] w-[100px] text-white rounded-md bg-[linear-gradient(86.92deg,#37ABFF_11.12%,rgba(255,255,255,0.2)_81.99%)]">
                      <NavLink
                        to="https://investor.bingold.to/signup"
                        target="_self"
                      >
                        <button className="bg-[#000] text-white h-[36px] w-full rounded-md font-semibold text-sm tracking-wide">
                          Sign Up
                        </button>
                      </NavLink>
                    </div>
                  </div>
                ) : (
                  <div className=" p-[2px] h-[40px] w-[180px] rounded-md bg-[linear-gradient(86.92deg,#37ABFF_11.12%,rgba(255,255,255,0.2)_81.99%)]">
                    <button
                      onClick={() => setShowLogoutPopup(true)}
                      className="bg-[#000] text-white h-[36px] w-full rounded-md font-semibold text-sm tracking-wide"
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <LogoutPop
        show={showLogoutPopup}
        setShow={setShowLogoutPopup}
        device={"This Device"}
        logoutType={"current"}
      />
    </nav>
  );
};

export default Navbar;
